const hasValue = (value: unknown): boolean =>
  value !== null && value !== undefined && value !== ''

export const hasNotEmptyProp =
  (prop: string) =>
  (obj?: Record<string, unknown>): boolean =>
    !!obj && hasValue(obj[prop])

export const hasNotEmptyProps =
  (props: string[]) =>
  (obj?: Record<string, unknown>): boolean =>
    props.every(x => hasNotEmptyProp(x)(obj))
